import React, { useState, useEffect, useRef, useCallback, memo } from 'react'
import PropTypes from 'prop-types'

const Float = ({ children, otherId, fromHeight = 0, customWindowWidth, isSticky }) => {
  const [style, setStyle] = useState({})
  const innerRef = useRef(null)
  const outerRef = useRef(null)

  const stickyCSSPropertyValue = isSticky ? 'sticky' : null

  const handleScrollResize = useCallback(() => {
    if (typeof document === 'undefined' || !innerRef.current || !outerRef.current) {
      return
    }

    const other = document.getElementById(otherId)
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const outerY = outerRef.current.getBoundingClientRect().top

    let actualFloatHeight = innerRef.current.clientHeight - fromHeight

    if (innerRef.current.children.length > 0) {
      const style = window.getComputedStyle(innerRef.current.children[innerRef.current.children.length - 1])
      actualFloatHeight += parseInt(style.marginBottom)
    }

    if (
      windowWidth < (customWindowWidth || 960) ||
      actualFloatHeight > windowHeight ||
      outerY - fromHeight > 0 ||
      !other
    ) {
      setStyle({ position: 'relative', marginTop: 0 })
    } else if (other) {
      const otherHeight = other.clientHeight
      if (otherHeight < actualFloatHeight) {
        setStyle({ position: 'relative', marginTop: 0 })
      } else {
        if (-outerY + actualFloatHeight + fromHeight > otherHeight - fromHeight) {
          setStyle({ position: 'relative', paddingTop: otherHeight - actualFloatHeight - fromHeight })
        } else {
          setStyle({
            position: stickyCSSPropertyValue || 'fixed',
            top: fromHeight,
            width: outerRef.current.clientWidth
          })
        }
      }
    }
  }, [customWindowWidth, fromHeight, otherId, stickyCSSPropertyValue])

  useEffect(() => {
    window.addEventListener('scroll', handleScrollResize)
    window.addEventListener('resize', handleScrollResize)
    handleScrollResize()

    return () => {
      window.removeEventListener('scroll', handleScrollResize)
      window.removeEventListener('resize', handleScrollResize)
    }
  }, [handleScrollResize])

  return (
    <div id='main-floater' className='main-floater' ref={outerRef}>
      <div style={style}>
        <div ref={innerRef}>{children}</div>
      </div>
    </div>
  )
}

Float.propTypes = {
  children: PropTypes.node,
  otherId: PropTypes.string,
  fromHeight: PropTypes.number,
  customWindowWidth: PropTypes.number,
  isSticky: PropTypes.bool
}

export default memo(Float)
